import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'PayBolt - Official IDO Page',
  description:
    '',
  image: 'https://www.paybolt.io/imgs/logo-paybolt-white.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else if (path.startsWith('/pancake-squad')) {
    basePath = '/pancake-squad'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('Home')} | ${t('BNBPay')}`,
      }
    case '/swap':
      return {
        title: `${t('Exchange')} | ${t('BNBPay')}`,
      }
    case '/add':
      return {
        title: `${t('Add Liquidity')} | ${t('BNBPay')}`,
      }
    case '/remove':
      return {
        title: `${t('Remove Liquidity')} | ${t('BNBPay')}`,
      }
    case '/liquidity':
      return {
        title: `${t('Liquidity')} | ${t('BNBPay')}`,
      }
    case '/find':
      return {
        title: `${t('Import Pool')} | ${t('BNBPay')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('BNBPay')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('BNBPay')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `${t('Leaderboard')} | ${t('BNBPay')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('BNBPay')}`,
      }
    case '/farms/auction':
      return {
        title: `${t('Farm Auctions')} | ${t('BNBPay')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('BNBPay')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('BNBPay')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('BNBPay')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('BNBPay')}`,
      }
    case '/voting':
      return {
        title: `${t('Voting')} | ${t('BNBPay')}`,
      }
    case '/voting/proposal':
      return {
        title: `${t('Proposals')} | ${t('BNBPay')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `${t('Make a Proposal')} | ${t('BNBPay')}`,
      }
    case '/info':
      return {
        title: `${t('Overview')} | ${t('BNBPay Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/info/pools':
      return {
        title: `${t('Pools')} | ${t('BNBPay Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/info/tokens':
      return {
        title: `${t('Tokens')} | ${t('BNBPay Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/nfts':
      return {
        title: `${t('Overview')} | ${t('BNBPay')}`,
      }
    case '/nfts/collections':
      return {
        title: `${t('Collections')} | ${t('BNBPay')}`,
      }
    case '/nfts/profile':
      return {
        title: `${t('Your Profile')} | ${t('BNBPay')}`,
      }
    case '/pancake-squad':
      return {
        title: `${t('Pancake Squad')} | ${t('BNBPay')}`,
      }
    default:
      return null
  }
}
